import React from 'react'
import PropTypes from 'prop-types'
import TextareaAutosize from 'react-textarea-autosize'

import './style.scss'

const TextInput = ({
  label,
  description,
  inputType,
  inputClass,
  value,
  inputChange,
  name,
  placeholder,
  disabled,
  onKeyPress,
  useTextArea,
  id,
  autoFocus,
  ref,
  required,
  showError,
  errorMessage,
  onFocus,
  onBlur,
  min,
  max,
  onPaste,
  tabIndex,
  spellCheck,
  onKeyUp,
  readOnly,
}: any) => {
  return (
    <div className="textinput-container">
      {label && (
        <label className="textinput-label">
          {label}
          <div className="textinput-description">{description}</div>
        </label>
      )}
      {!useTextArea && (
        <input
          required={required}
          ref={ref}
          className={`custom-input clr-black ${inputClass}`}
          type={inputType}
          value={value || ''}
          placeholder={placeholder}
          onChange={e => inputChange(e, name)}
          disabled={disabled}
          onKeyPress={onKeyPress}
          onKeyUp={onKeyUp}
          id={id}
          autoFocus={autoFocus}
          onFocus={onFocus}
          onBlur={onBlur}
          min={min}
          max={max}
          onPaste={onPaste}
          tabIndex={tabIndex}
          spellCheck={spellCheck}
          readOnly={readOnly}
        />
      )}
      {useTextArea && (
        <TextareaAutosize
          required={required}
          // inputRef={ref} // Check why this is not working
          ref={ref}
          className={`custom-input clr-black ${inputClass}`}
          // type={inputType} Earlier it was type
          itemType={inputType}
          value={value || ''}
          placeholder={placeholder}
          onChange={e => inputChange(e, name)}
          disabled={disabled}
          onKeyPress={onKeyPress}
          onKeyUp={onKeyUp}
          minRows={min ? min : 1}
          maxRows={max}
          id={id}
          autoFocus={autoFocus}
          onFocus={onFocus}
          onBlur={onBlur}
          onPaste={onPaste}
          tabIndex={tabIndex}
          spellCheck={spellCheck}
        />
      )}
      {showError && <div className="textinput-error">{errorMessage}</div>}
    </div>
  )
}

export default TextInput
